import React from "react";
import moment from "moment";

import connectToStores from "alt-utils/lib/connectToStores";
import EventBucketStore from "../stores/EventBucketStore";
import EventBucketActions from "../actions/EventBucketActions";
import AnalyticsStore from "../stores/AnalyticsStore";
import AnalyticsActions from "../actions/AnalyticsActions";
import EventStore from "../stores/EventStore";
import EventActions from "../actions/EventActions";
import PassBucketStore from "../stores/PassBucketStore";
import PassBucketActions from "../actions/PassBucketActions";

import AnalyticsHeader from "./partials/analytics-header.jsx";
import WorkingIndicator from "./partials/working-indicator.jsx";

import StatsBlockContainer from "./partials/stats-block-container.jsx";
import StatsBlock from "./partials/stats-block.jsx";

import EventPassesAnalyticsTable from "./partials/event-passes-analytics-table.jsx";
import AnalyticsFilterWidget from "./partials/analytics-filter-widget.jsx";

import FromCacheCallout from "./partials/from-cache-callout.jsx";

import { formatNumber } from "../util";

class EventPassesAnalytics extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      showRangeEditor: false,
      allTime: false,
      range: {
        key: "selection",
        startDate: moment().subtract(1, "month").format("YYYY-MM-DD"),
        endDate: moment().format("YYYY-MM-DD"),
      },
    };

    this.handleDateChange = this.handleDateChange.bind(this);
    this.setPage = this.setPage.bind(this);
  }

  static getStores() {
    return [EventBucketStore, EventStore, PassBucketStore, AnalyticsStore];
  }

  static getPropsFromStores() {
    const eventState = EventStore.getState(),
      passBucketState = PassBucketStore.getState();

    return {
      getEventBuckets: EventBucketStore.getEventBuckets,
      getEventBucketById: EventBucketStore.getEventBucketById,
      events: eventState.events,
      passBuckets: passBucketState.passBuckets,
      isFetching: eventState.isFetching || passBucketState.isFetching,
      getEventsForEventBucket: EventStore.getEventsForEventBucket,
      getEventPassesAnalytics: AnalyticsStore.getEventPassesAnalytics
    };
  }

  static contextTypes = {
    router: React.PropTypes.object
  };

  // Set the state of the page to reflect if we are on a 
  // pass page or a membership page.
  async setPage() {
    if (this.props.location.pathname.includes("memberships")) {
      await this.setState({ isMembership: true, filterState: "memberships" })
      this.componentWillReceiveProps(this.props, true);
    } else {
      await this.setState({ isMembership: false, filterState: "passes" })
      this.componentWillReceiveProps(this.props, true);
    }
  }

  handleDateChange({ range, allTime }) {
    this.setState({ range: range, allTime: allTime },
      () => this.componentWillReceiveProps(this.props, true)
    );
  }

  componentDidMount() {
    this.setPage(); // set state to reflect pass vs. membership
    this.componentWillReceiveProps(this.props, true);
  }

  componentDidUpdate(prevProps) {
    if (this.props.location !== prevProps.location) {
      this.setPage();  // set state to reflect pass vs. membership
    }
  }

  componentWillReceiveProps(newProps, force = false) {
    const isMembership = this.props.location.pathname.includes("membership");

    if (
      force === true ||
      newProps.params.eventBucketId !== this.props.params.eventBucketId
    ) {
      AnalyticsActions.fetchEventPassesAnalytics.defer({
        eventBucketId: newProps.params.eventBucketId,
        isMembership: isMembership,
        startDate: !this.state.allTime ? JSON.stringify(this.state.range.startDate) : null,
        endDate: !this.state.allTime ? JSON.stringify(this.state.range.endDate) : null,
        allTime: this.state.allTime,
      });
      EventActions.fetchAllForBucket.defer(newProps.params.eventBucketId);
      PassBucketActions.fetchAllForEventBucket.defer(
        newProps.params.eventBucketId
      );
      EventBucketActions.fetchOne.defer(newProps.params.eventBucketId);
    }
  }

  render() {
    const { eventBucketId } = this.props.params;
    if (!eventBucketId) {
      return <div><WorkingIndicator fullPage={true} /></div>
    }
    const eventBucket = this.props.getEventBucketById(eventBucketId);
    if (!eventBucket) {
      return <div><WorkingIndicator fullPage={true} /></div>
    }
    const { events, passBuckets, isFetching } = this.props;
    const eventBucketEvents = this.props.getEventsForEventBucket(eventBucketId);
    const eventPassesAnalytics = this.props.getEventPassesAnalytics(eventBucketId);
    const isMembership = this.props.location.pathname.includes("memberships");
    const defaultItemsPerPage = 25;

    return (
      <div>
        <AnalyticsHeader
          eventBucket={eventBucket}
          allEventBuckets={this.props.getEventBuckets()}
          label={`${isMembership ? "membership" : "pass"} ticket analytics`}
          subpath="event_passes"
        />
        <FromCacheCallout analytics={eventPassesAnalytics} />
        <AnalyticsFilterWidget
          key={!isMembership ? "membership" : "passes"}
          showDateFilter={true}
          onDateRangeChange={this.handleDateChange}
        />
        <p>
          Scroll down to view tickets ordered using a {isMembership ? "membership" : "pass"} for each event{" "}
          <a href="#by-pass-bucket">by {isMembership ? "membership" : "pass bucket"}</a> and{" "}
          <a href="#by-order-type">by order type</a>.
        </p>
        {
          !eventPassesAnalytics
            || !eventBucket
            || (eventBucketEvents.length === 0 && isFetching)
            || isFetching
            ? (
              <div><WorkingIndicator fullPage={true} /></div>
            ) : (
              <div>
                <StatsBlockContainer style={{ marginTop: -10 }}>
                  <StatsBlock
                    value={formatNumber(eventPassesAnalytics.total_ordered)}
                    label="Total pass tickets ordered"
                  />
                  <StatsBlock
                    value={formatNumber(eventPassesAnalytics.total_scanned)}
                    label="Total pass tickets scanned"
                  />
                </StatsBlockContainer>
                <a className="anchor--fixed_header_offset" id="by-pass-bucket" />
                <div className="analytics-element">
                  <h2 style={{ marginTop: "1em", marginBottom: "0.5em" }}>
                    Tickets ordered for event by {isMembership ? "membership" : "pass bucket"}
                  </h2>
                  <EventPassesAnalyticsTable
                    eventBucket={eventBucket}
                    events={events}
                    columnBy="pass_bucket"
                    passBuckets={passBuckets}
                    data={eventPassesAnalytics.volumes}
                    isMembership={isMembership}
                    itemsPerPage={defaultItemsPerPage}
                  />
                </div>
                <a className="anchor--fixed_header_offset" id="by-order-type" />
                <div className="analytics-element">
                  <h2 style={{ marginTop: "1em", marginBottom: "0.5em" }}>
                    Tickets ordered for event by order type
                  </h2>
                  <EventPassesAnalyticsTable
                    eventBucket={eventBucket}
                    events={events}
                    columnBy="order_type"
                    passBuckets={passBuckets}
                    data={eventPassesAnalytics.volumes}
                    isMembership={isMembership}
                    itemsPerPage={defaultItemsPerPage}
                  />
                </div>
              </div>)}
      </div>
    );
  }
}

export default connectToStores(EventPassesAnalytics);



// WEBPACK FOOTER //
// ./src/app/components/event-passes-analytics.jsx